/* eslint-disable react/require-default-props */
import React, { useRef, useState, useEffect } from 'react';

type FileUploadProps = {
  onFileSelect: (file: File) => void;
  accept?: string;
  maxSizeMB?: number;
  initialImageUrl?: string;
};

const FileUpload = ({
  onFileSelect,
  accept = 'image/*',
  maxSizeMB,
  initialImageUrl,
}: FileUploadProps) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [preview, setPreview] = useState<string | null>(initialImageUrl || null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (initialImageUrl) {
      setPreview(initialImageUrl);
    }
  }, [initialImageUrl]);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (maxSizeMB && file.size > maxSizeMB * 1024 * 1024) {
      setError(`Arquivo deve ter no máximo ${maxSizeMB}MB`);
      return;
    }

    setError(null);

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result as string);
    };
    reader.readAsDataURL(file);

    onFileSelect(file);
  };

  return (
    <div className="d-flex align-items-start">
      <button
        type="button"
        onClick={handleClick}
        className="d-flex align-items-center justify-content-center mr-3 p-0"
        style={{
          width: 86,
          height: 86,
          borderRadius: '50%',
          background: '#E9ECEF',
          border: '3px solid #fff',
          boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.2)',
          cursor: 'pointer',
          overflow: 'hidden',
        }}
      >
        {preview ? (
          <img
            src={preview}
            alt="Foto do usuário"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <i className="material-icons text-muted" style={{ fontSize: 34 }}>
            photo_camera
          </i>
        )}
      </button>

      <div>
        <input
          type="file"
          accept={accept}
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />

        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={handleClick}>
          <i className="material-icons align-middle mr-1" style={{ fontSize: 18 }}>
            upload
          </i>
          Escolher foto
        </button>
        {error && <div className="text-danger mt-2">{error}</div>}
        <div className="text-muted mt-2" style={{ fontSize: 13, lineHeight: 1.4 }}>
          <div>• Formatos aceitos: JPG, PNG, GIF</div>
          <div>• Tamanho máximo: 5MB</div>
          <div>• Recomendado: 400x400px ou maior</div>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
